import Vue from 'vue'
import Router from 'vue-router'
import Payment from '@/components/Payment'
import Login from '@/components/Login'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/',
      name: 'Payment',
      component: Payment,
      meta: {
        title: '付款计划表'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js